module.exports = __webpack_public_path__ + "img/ConceptoMovil-C.01f3dc01.png";